import React, { useState, useRef, useEffect } from "react";

export const SelectDropDown = ({ options, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0] || null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOptionClick = (option) => {
    setSelectedOption(option);  
    onSelect(option);
    setIsOpen(false);
  };

  return (
    <div className="relative w-fit px-3" ref={dropdownRef}>
      <div
        className="bg-[whiite] border border-[#E7E7E7] rounded-md px-3 py-1 flex items-center justify-between cursor-pointer"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className="text-[#1D242D] text-sm">   
          {selectedOption ? selectedOption.label : ''}
        </span>
        <span className={`ml-2 transform text-[#909DAD] text-sm ${isOpen ? "rotate-180" : ""}`}>
          ▼
        </span>
      </div>
      {isOpen && (
        <div className="absolute top-full left-0 w-full mt-4 bg-white border border-gray-300 rounded-lg shadow-lg z-10">
          {options.map((option) => (
            <div
              key={option.value}
              className="py-3 text-sm text-center text-sm text-[#0A0A0A] cursor-pointer"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
              <div className="h-[1px] w-full border-0 bg-[#DADADA] mt-2" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};